import { render, staticRenderFns } from "./PlatformManagement.vue?vue&type=template&id=27a3e581&scoped=true"
import script from "./PlatformManagement.vue?vue&type=script&lang=js"
export * from "./PlatformManagement.vue?vue&type=script&lang=js"
import style0 from "./PlatformManagement.vue?vue&type=style&index=0&id=27a3e581&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a3e581",
  null
  
)

export default component.exports